import GoogleSignInButton from 'components/auth/GoogleSignInButton';
import PageTitle from 'components/shared/PageTitle';
import { URLS } from 'config';

const Login: React.FunctionComponent = function () {
  return (
    <div className="flex h-vvp w-vvp">
      <PageTitle title="Staff Login" />
      <div className="m-auto">
        <GoogleSignInButton successUrl={URLS.staff} />
      </div>
    </div>
  );
};

export default Login;
